import { Button, Divider, Grid, List } from '@mui/material';
import { IMedication } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { goToRenewPrescription, goToRequestReferral } from 'Utils';
import { ExpiredMedicationItem } from './ExpiredMedicationItem';

interface IExpiredMedicationsProps {
  expiredMedications: IMedication[];
}

export const ExpiredMedicationsList = ({
  expiredMedications,
}: IExpiredMedicationsProps) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const btnStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: '38px',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: '400',
    border: '1px solid #1752AF',
  };

  return (
    <>
      <Divider
        aria-hidden='true'
        sx={{ width: '100%', borderColor: '#EDF2FB', mb: 3 }}
      />
      <List>
        {expiredMedications.map((expiredMedication, index) => {
          return (
            <ExpiredMedicationItem
              key={index}
              expiredMedication={expiredMedication}
            />
          );
        })}
      </List>
      <Grid item xs={12} mt={2}>
        <Button onClick={goToRequestReferral} variant='outlined' sx={btnStyle}>
          {dictionary.referralRequest}
        </Button>
      </Grid>
      <Grid item xs={12} mt={2} mb={15}>
        <Button
          onClick={() => goToRenewPrescription()}
          variant='outlined'
          sx={btnStyle}
        >
          {dictionary.successOrderLeftButton}
        </Button>
      </Grid>
    </>
  );
};
